/**
 * Fetches and displays customer loyalty points from Supabase Edge Function
 * @param {string} shopifyCustomerId - The Shopify customer ID
 * @param {string} apiBaseUrl - The base URL for the API
 */
async function getCustomerPoints(shopifyCustomerId, apiBaseUrl = 'https://xcldpqvrbwoiygcfrvtq.supabase.co/functions/v1/card-collection') {
    if (!shopifyCustomerId) {
        return;
    }

    const baseUrl = apiBaseUrl.replace(/\/$/, '');
    const apiUrl = `${baseUrl}/joy-points?customerId=${encodeURIComponent(shopifyCustomerId)}`;

    try {
        const response = await fetch(apiUrl);
        if (!response.ok) {
            throw new Error(`HTTP Error: ${response.status}`);
        }

        const result = await response.json();

        if (result.success && result.data) {
            const points = result.data.point;
            const pointElement = document.getElementById('customer-points');
            if (pointElement) {
                pointElement.innerText = points.toLocaleString('id-ID');
            }
        }
    } catch (error) {
        console.error('Error fetching customer points:', error);
        const pointElement = document.getElementById('customer-points');
        if (pointElement) pointElement.innerText = '-';
    }
}